import { Pipe } from "@angular/core";

@Pipe({
    name: 'phoneFormat',
    standalone: false
})
export class PhoneFormatePipe {
  transform(value: string) {
    let val: string;
    if (value) {
      val = value.replace(/-/g, '');
    };
    if (val) {
      if (val.length > 0 && val.length < 3) {
        return (`${val.slice(0, val.length)}`);
      } else if (val.length === 3) {
        return (`${val.slice(0, val.length)}-`);
      } else if (val.length > 3 && val.length < 6) {
        return (`${val.slice(0, 3)}-${val.slice(3, val.length)}`);
      } else if (val.length === 6) {
        return (`${val.slice(0, 3)}-${val.slice(3, val.length)}-`);
      } else if (val.length > 6) {
        return (`${val.slice(0, 3)}-${val.slice(3, 6)}-${val.slice(6, val.length)}`);
      };
    } else {
      return null;
    }
  };
};